module.exports = __webpack_public_path__ + "static/hackathon-ideation-8676f6c53da280c5408571d821439890.png";